import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Box } from '@mui/material';
import React from 'react';
import { SidebarAccordion } from 'src/components/accordion';
import { Drawer } from 'src/components/drawer';
import { SidebarHeader } from 'src/components/header';
import { ProductsSidebar } from 'src/components/productsSidebar';
import { ComponentTypes } from 'src/interfaces';

import { EditLVGProductsProps } from '../OOEditProducts.interface';
import {
  EditProductsWrapper,
  SidebarContainer,
  SidebarContent,
} from '../OOEditProducts.styled';

export const OOLvgEditProductsComponent = (props: EditLVGProductsProps) => {
  const [openProductsDrawer, setOpenProductsDrawer] = React.useState(false);

  return (
    <Box>
      <EditProductsWrapper>
        <SidebarContent>
          <SidebarAccordion
            items={[
              {
                label: 'Products',
                onLabelClick: () => setOpenProductsDrawer(!openProductsDrawer),
                content: <div />,
                chevronIcon: <NavigateNextIcon />,
                disabledExpand: true,
                hasError: false,
              },
            ]}
          />
        </SidebarContent>
      </EditProductsWrapper>
      <Drawer open={openProductsDrawer}>
        <SidebarContainer>
          <SidebarHeader
            label="Products"
            onBackClick={() => setOpenProductsDrawer(false)}
          />
          <SidebarContent>
            <ProductsSidebar
              componentType={ComponentTypes.LISTING_VISUALS_GALLERY}
              componentConfig={props.selectedComponent?.config}
              onBackClick={() => setOpenProductsDrawer(false)}
              onChangedComponentConfigField={props.onOverrideConfig}
              productCategoryIDs={
                props.selectedComponent?.product_category_id || []
              }
              themeId={
                props.selectedComponent?.theme_id ||
                props.selectedComponent?.config?.themeId
              }
            />
          </SidebarContent>
        </SidebarContainer>
      </Drawer>
    </Box>
  );
};
